import { BetServiceEvent, IServices } from "@netent/origin";
import { IPlayUIState, View } from "@netent/playui";
import { ListenerCreator } from "../../types";

const changed = ({ bet, money }: IServices) => (): IPlayUIState => ({
  bet: {
    denominations: bet.getDenominations(),
    denomination: bet.getDenomination(),
    size: bet.getBetSize(),
    level: bet.getBetLevel(),
    levels: bet.getBetLevels(),
    valueInCoins: bet.getBetCoins(),
    valueInCash: bet.getBetCash()
  },
  balance: {
    valueInCash: money.getBalanceCash(),
    valueInCoins: money.getBalanceCoins()
  }
});

const limitReached = () => (): IPlayUIState => ({
  view: View.BET_SETTINGS
});

const reInitDataUpdated = ({ bet }: IServices) => (): IPlayUIState => ({
  bet: {
    denominations: bet.getDenominations(),
    denomination: bet.getDenomination(),
    size: bet.getBetSize(),
    level: bet.getBetLevel(),
    levels: bet.getBetLevels(),
    valueInCoins: bet.getBetCoins(),
    valueInCash: bet.getBetCash()
  }
});

export const listeners = new Map<BetServiceEvent, ListenerCreator>([
  ["changed", changed],
  ["limitReached", limitReached],
  ["reInitDataUpdated", reInitDataUpdated]
]);
